import './App.css';
import Navbar from './components/navbar';
import About from './page/about';
import Banner from './page/banner';
import FavProduct from './page/favProduct';
import Footer from './page/footer';
import Product from './page/product';
import Reason from './page/reason';
import Testimonials from './page/testimonials';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Banner />
      <About />
      <Product />
      <Reason />
      <FavProduct />
      <Testimonials />
      <Footer />
    </div>
  );
}

export default App;
